import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Field, useFormikContext } from "formik";
import "./SelectButton";
import { useSelector } from "react-redux";
import { selectProfile } from "../../store/slices/profile-slice";
import { GeneralSelect } from "../Custom-Forms/General-Select";
import Button from "react-bootstrap/Button";
import "./Profile.css";
import "react-toastify/dist/ReactToastify.css";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { GeneralRadioGroupInput } from "../Custom-Forms/General-Radio-Group-Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faCheck } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import Card from "react-bootstrap/Card";
import prettyBytes from "pretty-bytes";
import {
    formateUploadDate,
    formatDateToInputFormat,
    formatDateToOutputFormat,
} from "./util/helpers.js";
import { FileUpload } from "../File-Upload/File-Upload";
import { FileUploadDelete } from "../File-Upload/File-Upload-Delete";
import { MdKeyboardReturn } from "react-icons/md";

export const EducationDetails = () => {
    const profile = useSelector(selectProfile);
    const { values, setValues, errors, submitForm, setFieldValue } = useFormikContext();

    const [uploadHSForm, setUploadHSForm] = useState(false);
    const [uploadCollege1, setUploadCollege1] = useState(false);
    const [uploadCollege2, setUploadCollege2] = useState(false);
    const [uploadSchools, setUploadSchools] = useState(false);
    const [uploadAddInfo4, setUploadAddInfo4] = useState(false);
    const [uploadAddInfo5, setUploadAddInfo5] = useState(false);
    const [uploadAddInfo6, setUploadAddInfo6] = useState(false);


    const [checkEducation, setCheckEducation] = useState(false)

    const education = [
        "Did Not Graduate",
        "High School Diploma",
        "Graduate Equivalency Degree (GED)",
    ];
    const degrees = [
        "Some College But No Degree",
        "Associate of Arts (AA)",
        "Associate of Science (AS)",
        "Bachelor of Arts (BA)",
        "Bachelor of Science (BS)",
        "Bachelor of Fine Arts (BFA)",
        "Bachelor of Business Administration (BBA)",
        "Bachelor of Engineering (BEng)",
        "Master of Arts (MA)",
        "Master of Science (MS)",
        "Master of Business Administration (MBA)",
        "Master of Fine Arts (MFA)",
        "Doctor of Philosophy (PhD)",
        "Juris Doctor (JD)",
        "Doctor of Medicine (MD)",
        "Doctor of Education (EdD)",
        "Certificate",
    ];


    function areFieldsFilled(fieldNames, values) {
        return fieldNames.every((fieldName) => Boolean(values[fieldName]));
    }
    const areEducationFieldsFilled = (values) => {
        const fields = {
            attendedHighSchool: [
                "highSchoolName",
                "highSchoolAddress",
                "education",
                "highSchoolStart",
                "highSchoolEnd",
            ],
            attendedCollege1: [
                "collegeName1",
                "collegeAddress1",
                "degree1",
                "major1",
                "collegeStart1",
                "collegeEnd1",
                "collegeCreditHours1",
            ],
            attendedCollege2: [
                "collegeName2",
                "collegeAddress2",
                "degree2",
                "major2",
                "collegeStart2",
                "collegeEnd2",
                "collegeCreditHours2",
            ],
            attendedTechSchool: [
                "techSchoolName1",
                "techSchoolAddress1",
                "techDegree1",
                "techMajor1",
                "techStart1",
                "techEnd1",
                "techCreditHours1",
            ],
        };

        for (const [attended, requiredFields] of Object.entries(fields)) {
            if (values[attended] === "") return false;
            if (
                values[attended] === "Yes" &&
                !areFieldsFilled(requiredFields, values)
            )
                return false;
        }

        return true;
    };



    useEffect(() => {  
        if(
            values.attendedHighSchool === "Yes" || 
            values.attendedTechSchool === "Yes" ||
            values.attendedCollege2 === "Yes" ||
            values.attendedCollege1 === "Yes"
        ){
            setCheckEducation(true)
        } else {
            setCheckEducation(false)
        }
    }, [values])

    return (
        <>
            <Container className="container2 px-3">
                {areEducationFieldsFilled(values) && (
                    <div
                        className="alert alert-success text-center success-msg animate__animated animate__fadeInUp mt-2 mb-0"
                        role="alert"
                    >
                        <h4 className="alert-heading fw-bold fs-5 fs-md-4">
                            <FontAwesomeIcon
                                icon={faCheck}
                                style={{
                                    color: "cornflowerblue",
                                    fontSize: "1.5em",
                                }}
                                className="fa-fw fa-xs d-md-inline-block me-md-2 pt-1"
                            />
                        </h4>
                        Great! You can proceed to the next step.
                    </div>
                )}
                <Row className="d-flex justify-content-center">

                    <h3 className="header-font"><span>Education Details</span></h3>



                </Row>

                {
                    <>
                        <Row className="d-flex justify-content-center mt-3 ">
                            <Col xs={"auto"} className="mx-0">
                                <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                                    Do you have your High School education details?
                                </label>
                            </Col>
                        </Row>
                        {values.attendedHighSchool === "" && (
                            <>
                                <Row className="d-flex justify-content-center ">
                                    <div className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                        Please Make a Selection
                                    </div>
                                </Row>
                            </>
                        )}
                        <Row
                            className=" d-flex justify-content-center"
                            style={{ marginTop: "-12px" }}
                        >
                            <Col className="d-flex justify-content-center  mb-4">
                                <GeneralRadioGroupInput
                                    name="attendedHighSchool"
                                    onChange={(e) => {
                                        setValues((prevValues) => ({
                                            ...prevValues,
                                            attendedHighSchool: e.target.value,
                                            ...(e.target.value === "No" && {
                                                highSchoolName: "",
                                                highSchoolAddress: "",
                                                education: "",
                                                highSchoolStart: "",
                                                highSchoolEnd: "",
                                            }),
                                        }));
                                    }}
                                />
                            </Col>
                        </Row>
                    </>
                }
                <Card style={{ padding: 0 }} className="full-width-card">
                    {values.attendedHighSchool === "Yes" &&
                        (
                            <>

                                <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                    <h3 className="header-font"><span>High School</span></h3>

                                    <Button
                                        className="transparent-btn me-2 position-absolute end-0"
                                        onClick={async () => {
                                            let result = await Swal.fire({
                                                title: "Are you sure?",
                                                text: "You won't be able to revert this!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#3085d6",
                                                cancelButtonColor: "#d33",
                                                confirmButtonText:
                                                    "Yes, delete it!",
                                            });

                                            if (result.isConfirmed) {
                                                let valuesCopy = {
                                                    ...values,
                                                };
                                                valuesCopy.highSchoolName = "";
                                                valuesCopy.highSchoolAddress =
                                                    "";
                                                valuesCopy.highSchoolStart = "";
                                                valuesCopy.highSchoolEnd = "";
                                                valuesCopy.education = "";

                                                setValues(valuesCopy);

                                                await submitForm();
                                            }
                                        }}
                                    >
                                        <FaTrashAlt
                                            className="icon trash-icon"
                                            style={{ fontSize: "20px" }}
                                        />
                                    </Button>
                                </Card.Header>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            High School Name
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="highSchoolName"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            High School Address
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="2"
                                            name="highSchoolAddress"
                                            maxLength={200}
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            From
                                        </label>

                                        <GeneralTextAreaField
                                            className="form-control"
                                            type="date"
                                            name="highSchoolStart"
                                            value={formatDateToInputFormat(
                                                values.highSchoolStart,
                                            )}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            To
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            type="date"
                                            name="highSchoolEnd"
                                            value={formatDateToInputFormat(
                                                values.highSchoolEnd,
                                            )}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4 mb-5">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            GED/Diploma Received
                                        </label>
                                        <GeneralSelect name="education">
                                            <option value="">Select One</option>
                                            {education.map((item) => {
                                                return (
                                                    <option
                                                        key={item}
                                                        value={item}
                                                    >
                                                        {item}
                                                    </option>
                                                );
                                            })}
                                        </GeneralSelect>
                                    </Col>
                                </Row>
                            </>
                        )}

                    {/* ====================== HS UPLOAD START ====================== */}
                    {values.attendedHighSchool === "Yes" && (
                        <Card>
                            <Card.Header
                                className="header-card"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <span>
                                    Additional Information:&nbsp;Upload High
                                    School Degree/Certificate:
                                </span>
                            </Card.Header>
                            {profile.HS_FormIn === "Yes" && (
                                <Card.Body className="pb-0">
                                    <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                        <Col className="py-3">
                                            <Row>
                                                <Col className="text-center">
                                                    <h5 className="border-bottom border-warning border-5">
                                                    High School Diploma/GED On File:
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>File Name:</b>{" "}
                                                    {
                                                        profile.HS_Form_OriginalName
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Upload Date:</b>{" "}
                                                    {formateUploadDate(
                                                        profile.HS_Form_UploadDate,
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Size:</b>{" "}
                                                    {profile.HS_Form_FileSize
                                                        ? prettyBytes(
                                                            parseInt(
                                                                profile.HS_Form_FileSize,
                                                            ),
                                                        )
                                                        : ""}
                                                </Col>
                                            </Row>

                                            <Row>
                                                <FileUploadDelete
                                                    containerName={"HS_Form"}
                                                    fileName={
                                                        profile.HS_Form_OriginalName
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            )}

                            {uploadHSForm && (
                                <FileUpload containerName={"HS_Form"} />
                            )}

                            {profile.HS_FormIn === "No" && 
                                !uploadHSForm && (
                                <Col className="d-flex justify-content-center footer-color py-3">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadHSForm ? "btn-danger" : ""
                                        }
                                        onClick={() =>
                                            setUploadHSForm(!uploadHSForm)
                                        }
                                    >
                                        {uploadHSForm
                                            ? "Cancel"
                                            : "Upload New Diploma/GED"}
                                    </Button>
                                </Col>
                            )}
                        </Card>
                    )}
                    {/* ====================== HS UPLOAD END ====================== */}
                </Card>

                {
                    <>
                        <Row className="d-flex justify-content-center mt-3 ">
                            <Col xs={"auto"} className="mx-0">
                                <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                                    Do you have your college
                                    details?
                                </label>
                            </Col>
                        </Row>
                        {values.attendedCollege1 === "" && (
                            <Row className="d-flex justify-content-center ">
                                <div className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                    Please Make a Selection
                                </div>
                            </Row>
                        )}
                        <Row
                            className=" d-flex justify-content-center"
                            style={{ marginTop: "-12px" }}
                        >
                            <Col className="d-flex justify-content-center ">
                                <GeneralRadioGroupInput
                                    name="attendedCollege1"
                                    onChange={(e) => {
                                        setValues((prevValues) => ({
                                            ...prevValues,
                                            attendedCollege1: e.target.value,
                                            ...(e.target.value === "No" && {
                                                collegeName1: "",
                                                collegeAddress1: "",
                                                degree1: "",
                                                major1: "",
                                                minor1: "",
                                                collegeStart1: "",
                                                collegeEnd1: "",
                                                collegeCreditHours1: "",
                                            }),
                                        }));
                                    }}
                                />
                            </Col>
                        </Row>
                    </>
                }

                <Card style={{ padding: 0 }} className="my-4 full-width-card">
                    {values.attendedCollege1 === "Yes" &&
                       (
                            <>


                                <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                    <h3 className="header-font"><span>College</span></h3>

                                    <Button
                                        className="transparent-btn me-2 position-absolute end-0"
                                        onClick={async () => {
                                            let result = await Swal.fire({
                                                title: "Are you sure?",
                                                text: "You won't be able to revert this!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#3085d6",
                                                cancelButtonColor: "#d33",
                                                confirmButtonText:
                                                    "Yes, delete it!",
                                            });

                                            if (result.isConfirmed) {
                                                let valuesCopy = {
                                                    ...values,
                                                };
                                                valuesCopy.collegeName1 = "";
                                                valuesCopy.collegeAddress1 = "";
                                                valuesCopy.degree1 = "";
                                                valuesCopy.major1 = "";
                                                valuesCopy.minor1 = "";
                                                valuesCopy.collegeStart1 = "";
                                                valuesCopy.collegeEnd1 = "";
                                                valuesCopy.collegeCreditHours1 =
                                                    "";
                                                valuesCopy.attendedCollege1 = "No";

                                                setValues(valuesCopy);

                                                await submitForm();
                                            }
                                        }}
                                    >
                                        <FaTrashAlt
                                            className="icon trash-icon"
                                            style={{ fontSize: "20px" }}
                                        />
                                    </Button>
                                </Card.Header>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            College Name
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="collegeName1"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7} >
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            College Address
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="2"
                                            name="collegeAddress1"
                                            maxLength={200}
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7} className="px-0 mx-0">
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Degree
                                        </label>
                                        <Field name="degree1" >
                                            {({ field, meta }) => {


                                                let validationCheck;

                                                if (meta.touched && meta.error) {
                                                    validationCheck = "is-invalid";
                                                } else if (
                                                    meta.touched &&
                                                    !meta.error
                                                ) {
                                                    validationCheck = "is-valid";
                                                }
                                                const handleChange = (evt) => {
                                                    field.onChange(evt);

                                                    if (evt.currentTarget.value !== "Some College But No Degree") {
                                                        setFieldValue("collegeCreditHours1", "0");
                                                    }
                                                    else setFieldValue("collegeCreditHours1", "");
                                                };
                                                return (
                                                    <>
                                                        <select className={
                                                            "form-control " +
                                                            validationCheck
                                                        }        {...field} onChange={handleChange}>
                                                            <option value="">Select One</option>
                                                            {degrees.map((item) => {
                                                                return (
                                                                    <option
                                                                        key={item}
                                                                        value={item}
                                                                    >
                                                                        {item}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                        {!meta.touched &&
                                                            meta.error ? (
                                                            <p className="text-danger py-0 my-0 ">
                                                                {meta.error}
                                                            </p>
                                                        ) : null}
                                                        {meta.touched &&
                                                            meta.error ? (
                                                            <p className="text-danger py-0 my-0">
                                                                {meta.error}
                                                            </p>
                                                        ) : null}
                                                    </>
                                                );
                                            }}
                                        </Field>

                                    </Col>
                                </Row>

                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Major
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="major1"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Minor
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="minor1"
                                            placeholder="Optional"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} sm={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            From
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            type="date"
                                            name="collegeStart1"
                                            value={formatDateToInputFormat(
                                                values.collegeStart1,
                                            )}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} sm={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            To
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            type="date"
                                            name="collegeEnd1"
                                            value={formatDateToInputFormat(
                                                values.collegeEnd1,
                                            )}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Col>
                                </Row>
                                {values.degree1 === "Some College But No Degree" ? (<>
                                    <Row className="d-flex justify-content-center mb-4 w-100 mx-auto mt-4 mb-5">
                                        <Col xs={10} sm={7}>
                                            <label
                                                className="info-label mr-1 pt-1 "
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Credit Hours
                                            </label>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                component="input"
                                                type="text"
                                                name="collegeCreditHours1"
                                            />
                                        </Col>
                                    </Row></>) : <><div className="mb-5" /></>}

                            </>
                        )}

                    {/* ====================== HS UPLOAD START ====================== */}
                    {values.attendedCollege1 === "Yes" && (
                        <Card>
                            <Card.Header
                                className="header-card"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <span>
                                    {" "}
                                    Additional Information:&nbsp;Upload College Diploma:
                                </span>
                            </Card.Header>
                            {profile.College1_FormIn === "Yes" && (
                                <Card.Body className="pb-0">
                                    <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                        <Col className="py-3">
                                            <Row>
                                                <Col className="text-center">
                                                    <h5 className="border-bottom border-warning border-5">
                                                    College Diploma On File:
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>File Name:</b>{" "}
                                                    {
                                                        profile.College1_Form_OriginalName
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Upload Date:</b>{" "}
                                                    {formateUploadDate(
                                                        profile.College1_Form_UploadDate,
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Size:</b>{" "}
                                                    {profile.College1_Form_FileSize
                                                        ? prettyBytes(
                                                            parseInt(
                                                                profile.College1_Form_FileSize,
                                                            ),
                                                        )
                                                        : ""}
                                                </Col>
                                            </Row>

                                            <Row>
                                                <FileUploadDelete
                                                    containerName={
                                                        "College1_Form"
                                                    }
                                                    fileName={
                                                        profile.College1_Form_OriginalName
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            )}

                            {uploadCollege1 && (
                                <FileUpload containerName={"College1_Form"} />
                            )}

                            {profile.College1_FormIn === "No" && 
                                !uploadCollege1 && (
                                <Col className="d-flex justify-content-center py-3 ">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadCollege1 ? "btn-danger" : ""
                                        }
                                        onClick={() =>
                                            setUploadCollege1(!uploadCollege1)
                                        }
                                    >
                                        {uploadCollege1
                                            ? "Cancel"
                                            : "Upload New Diploma"}
                                    </Button>
                                </Col>
                            )}
                                    <Card.Header
                                    className="header-card"
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                       <span>
                                            Upload College Transcript:
                                        </span>
                                    </Card.Header>
                                    <Card.Body>
                                        {profile.Additional_Info_Field_4In === "Yes" && (
                                            <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                                <Col className="py-3">
                                                    <Row>
                                                        <Col className="text-center">
                                                            <h5 className="border-bottom border-warning border-5">
                                                                {" "}
                                                                Current College Transcript on File:
                                                            </h5>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <b>File Name:</b>{" "}
                                                            {
                                                                profile.Additional_Info_Field_4_OriginalName
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <b>Upload Date:</b>{" "}
                                                            {formateUploadDate(
                                                                profile.Additional_Info_Field_4_UploadDate,
                                                            )}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <b>Size:</b>{" "}
                                                            {profile.Additional_Info_Field_4_FileSize
                                                                ? prettyBytes(
                                                                    parseInt(
                                                                        profile.Additional_Info_Field_4_FileSize,
                                                                    ),
                                                                )
                                                                : ""}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <FileUploadDelete
                                                            containerName={
                                                                "Additional_Info_Field_4"
                                                            }
                                                            fileName={
                                                                profile.Additional_Info_Field_4_OriginalName
                                                            }
                                                        />
                                                    </Row>
                                                </Col>
                                            </Row>
                                        )}
                                    </Card.Body>
                                    {uploadAddInfo4 && (
                                        <FileUpload
                                            containerName={"Additional_Info_Field_4"}
                                        />
                                    )}
                                    {profile.Additional_Info_Field_4In === "No" &&
                                        !uploadAddInfo4 && (
                                            <Col className="d-flex justify-content-center mb-4">
                                                <Button
                                                    variant="primary"
                                                    className={
                                                        uploadAddInfo4 ? "btn-danger" : ""
                                                    }
                                                    onClick={() =>
                                                        setUploadAddInfo4(!uploadAddInfo4)
                                                    }
                                                >
                                                    {uploadAddInfo4
                                                        ? "Cancel"
                                                        : "Upload College Transcript"}
                                                </Button>
                                            </Col>
                                        )}
                        </Card>
                    )}
                    {/* ====================== HS UPLOAD END ====================== */}
                </Card>

                {
                    <>
                        <Row className="d-flex justify-content-center mt-3 ">
                            <Col xs={"auto"} className="mx-0">
                                <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                                    Do you have an additional college details?
                                </label>
                            </Col>
                        </Row>
                        {values.attendedCollege2 === "" && (
                            <Row className="d-flex justify-content-center ">
                                <div className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                    Please Make a Selection
                                </div>
                            </Row>
                        )}
                        <Row
                            className=" d-flex justify-content-center"
                            style={{ marginTop: "-12px" }}
                        >
                            <Col className="d-flex justify-content-center ">
                                <GeneralRadioGroupInput
                                    name="attendedCollege2"
                                    onChange={(e) => {
                                        setValues((prevValues) => ({
                                            ...prevValues,
                                            attendedCollege2: e.target.value,
                                            ...(e.target.value === "No" && {
                                                collegeName2: "",
                                                collegeAddress2: "",
                                                degree2: "",
                                                major2: "",
                                                minor2: "",
                                                collegeStart2: "",
                                                collegeEnd2: "",
                                                collegeCreditHours2: "",
                                            }),
                                        }));
                                    }}
                                />
                            </Col>
                        </Row>
                    </>
                }

                <Card style={{ padding: 0 }} className="my-4 full-width-card">
                    {values.attendedCollege2 === "Yes" &&
                        (
                            <>

                                <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                    <h3 className="header-font"><span>Additional College</span></h3>

                                    <Button
                                        className="transparent-btn me-2 position-absolute end-0"
                                        onClick={async () => {
                                            let result = await Swal.fire({
                                                title: "Are you sure?",
                                                text: "You won't be able to revert this!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#3085d6",
                                                cancelButtonColor: "#d33",
                                                confirmButtonText:
                                                    "Yes, delete it!",
                                            });

                                            if (result.isConfirmed) {
                                                let valuesCopy = {
                                                    ...values,
                                                };
                                                valuesCopy.collegeName2 = "";
                                                valuesCopy.collegeAddress2 = "";
                                                valuesCopy.degree2 = "";
                                                valuesCopy.major2 = "";
                                                valuesCopy.minor2 = "";
                                                valuesCopy.collegeStart2 = "";
                                                valuesCopy.collegeEnd2 = "";
                                                valuesCopy.collegeCreditHours2 =
                                                    "";
                                                valuesCopy.attendedCollege2 = "No"

                                                setValues(valuesCopy);

                                                await submitForm();
                                            }
                                        }}
                                    >
                                        <FaTrashAlt
                                            className="icon trash-icon"
                                            style={{ fontSize: "20px" }}
                                        />
                                    </Button>
                                </Card.Header>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            College Name
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="collegeName2"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            College Address
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="2"
                                            name="collegeAddress2"
                                            maxLength={200}
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7} className="px-0 mx-0">
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Degree
                                        </label>
                                        <Field name="degree2" >
                                            {({ field, meta }) => {


                                                let validationCheck;

                                                if (meta.touched && meta.error) {
                                                    validationCheck = "is-invalid";
                                                } else if (
                                                    meta.touched &&
                                                    !meta.error
                                                ) {
                                                    validationCheck = "is-valid";
                                                }
                                                const handleChange = (evt) => {
                                                    field.onChange(evt);

                                                    if (evt.currentTarget.value !== "Some College But No Degree") {
                                                        setFieldValue("collegeCreditHours2", "0");
                                                    }
                                                    else setFieldValue("collegeCreditHours2", "");
                                                };
                                                return (
                                                    <>
                                                        <select className={
                                                            "form-control " +
                                                            validationCheck
                                                        }        {...field} onChange={handleChange}>
                                                            <option value="">Select One</option>
                                                            {degrees.map((item) => {
                                                                return (
                                                                    <option
                                                                        key={item}
                                                                        value={item}
                                                                    >
                                                                        {item}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                        {!meta.touched &&
                                                            meta.error ? (
                                                            <p className="text-danger py-0 my-0 ">
                                                                {meta.error}
                                                            </p>
                                                        ) : null}
                                                        {meta.touched &&
                                                            meta.error ? (
                                                            <p className="text-danger py-0 my-0">
                                                                {meta.error}
                                                            </p>
                                                        ) : null}
                                                    </>
                                                );
                                            }}
                                        </Field>

                                    </Col>
                                </Row>

                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Major
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="major2"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Minor
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="minor2"
                                            placeholder="Optional"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            From
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            type="date"
                                            name="collegeStart2"
                                            value={formatDateToInputFormat(
                                                values.collegeStart2,
                                            )}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            To
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            type="date"
                                            name="collegeEnd2"
                                            value={formatDateToInputFormat(
                                                values.collegeEnd2,
                                            )}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Col>
                                </Row>

                                {values.degree2 === "Some College But No Degree" ? (<>
                                    <Row className="d-flex justify-content-center mb-4 w-100 mx-auto mt-4 mb-5">
                                        <Col xs={10} sm={7}>
                                            <label
                                                className="info-label mr-1 pt-1 "
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Credit Hours
                                            </label>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                component="input"
                                                type="text"
                                                name="collegeCreditHours2"
                                            />
                                        </Col>
                                    </Row></>) : <><div className="mb-5" /></>}
                            </>
                        )}

                    {/* ====================== HS UPLOAD START ====================== */}
                    {values.attendedCollege2 === "Yes" && (
                        <Card>
                            <Card.Header
                                className="header-card"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <span>
                                    {" "}
                                    Additional Information:&nbsp;Upload College
                                    #2 New Diploma:
                                </span>
                            </Card.Header>
                            {profile.College2_FormIn === "Yes" && (
                                <Card.Body className="pb-0">
                                    <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                        <Col className="py-3">
                                            <Row>
                                                <Col className="text-center">
                                                    <h5 className="border-bottom border-warning border-5">
                                                    College #2 Diploma On File:
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>File Name:</b>{" "}
                                                    {
                                                        profile.College2_Form_OriginalName
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Upload Date:</b>{" "}
                                                    {formateUploadDate(
                                                        profile.College2_Form_UploadDate,
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Size:</b>{" "}
                                                    {profile.College2_Form_FileSize
                                                        ? prettyBytes(
                                                            parseInt(
                                                                profile.College2_Form_FileSize,
                                                            ),
                                                        )
                                                        : ""}
                                                </Col>
                                            </Row>

                                            <Row>
                                                <FileUploadDelete
                                                    containerName={
                                                        "College2_Form"
                                                    }
                                                    fileName={
                                                        profile.College2_Form_OriginalName
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            )}

                            {uploadCollege2 && (
                                <FileUpload containerName={"College2_Form"} />
                            )}

                            {profile.College2_FormIn === "No" && 
                                !uploadCollege2 && (
                                <Col className="d-flex justify-content-center py-3">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadCollege2 ? "btn-danger" : ""
                                        }
                                        onClick={() =>
                                            setUploadCollege2(!uploadCollege2)
                                        }
                                    >
                                        {uploadCollege2
                                            ? "Cancel"
                                            : "Upload New Diploma"}
                                    </Button>
                                </Col>
                            )}
                                <Card.Header
                                className="header-card"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "10px",
                                    }}
                                >
                                    <span>
                                        Upload College #2 Transcripts:
                                    </span>
                                </Card.Header>
                                <Card.Body>
                                    {profile.Additional_Info_Field_5In === "Yes" && (
                                        <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                            <Col className="py-3">
                                                <Row>
                                                    <Col className="text-center">
                                                        <h5 className="border-bottom border-warning border-5">
                                                            {" "}
                                                            Current College #2 Transcripts on File:
                                                        </h5>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>File Name:</b>{" "}
                                                        {
                                                            profile.Additional_Info_Field_5_OriginalName
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>Upload Date:</b>{" "}
                                                        {formateUploadDate(
                                                            profile.Additional_Info_Field_5_UploadDate,
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>Size:</b>{" "}
                                                        {profile.Additional_Info_Field_5_FileSize
                                                            ? prettyBytes(
                                                                parseInt(
                                                                    profile.Additional_Info_Field_5_FileSize,
                                                                ),
                                                            )
                                                            : ""}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <FileUploadDelete
                                                        containerName={
                                                            "Additional_Info_Field_5"
                                                        }
                                                        fileName={
                                                            profile.Additional_Info_Field_5_OriginalName
                                                        }
                                                    />
                                                </Row>
                                            </Col>
                                        </Row>
                                    )}
                                </Card.Body>
                                {uploadAddInfo5 && (
                                    <FileUpload
                                        containerName={"Additional_Info_Field_5"}
                                    />
                                )}

                                {profile.Additional_Info_Field_5In === "No" &&
                                    !uploadAddInfo5 && (
                                        <Col className="d-flex justify-content-center mb-4">
                                            <Button
                                                variant="primary"
                                                className={
                                                    uploadAddInfo5 ? "btn-danger" : ""
                                                }
                                                onClick={() =>
                                                    setUploadAddInfo5(!uploadAddInfo5)
                                                }
                                            >
                                                {uploadAddInfo5
                                                    ? "Cancel"
                                                    : "Upload College #2 Transcripts"}
                                            </Button>
                                        </Col>
                                    )}
                        </Card>
                    )}
                </Card>
                {/* ====================== HS UPLOAD END ====================== */}

                {
                    <>
                        <Row className="d-flex justify-content-center  mt-3">
                            <Col xs={"auto"} className="mx-0">
                                <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                                    Do you have your
                                    Technical/Vocational/Business school
                                    details?
                                </label>
                            </Col>
                        </Row>
                        {values.attendedTechSchool === "" && (
                            <Row className="d-flex justify-content-center ">
                                <div className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                    Please Make a Selection
                                </div>
                            </Row>
                        )}
                        <Row
                            className=" d-flex justify-content-center"
                            style={{ marginTop: "-12px" }}
                        >
                            <Col className="d-flex justify-content-center">
                                <GeneralRadioGroupInput
                                    name="attendedTechSchool"
                                    onChange={(e) => {
                                        setValues((prevValues) => ({
                                            ...prevValues,
                                            attendedTechSchool: e.target.value,
                                            ...(e.target.value === "No" && {
                                                techSchoolName1: "",
                                                techSchoolAddress1: "",
                                                techDegree1: "",
                                                techMajor1: "",
                                                techMinor1: "",
                                                techStart1: "",
                                                techEnd1: "",
                                                techCreditHours1: "",
                                            }),
                                        }));
                                    }}
                                />
                            </Col>
                        </Row>
                    </>
                }

                <Card style={{ padding: 0 }} className="my-4 full-width-card">
                    {values.attendedTechSchool === "Yes" &&
                       (
                            <>
                                <Card.Header className="d-flex justify-content-center position-relative align-items-center bottom-border w-100 mx-auto">
                                    <h3 className="header-font"><span>Technical/Vocational/Business</span></h3>

                                    <Button
                                        className="transparent-btn me-2 position-absolute end-0"
                                        onClick={async () => {
                                            let result = await Swal.fire({
                                                title: "Are you sure?",
                                                text: "You won't be able to revert this!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#3085d6",
                                                cancelButtonColor: "#d33",
                                                confirmButtonText:
                                                    "Yes, delete it!",
                                            });

                                            if (result.isConfirmed) {
                                                let valuesCopy = {
                                                    ...values,
                                                };
                                                valuesCopy.techSchoolName1 = "";
                                                valuesCopy.techSchoolAddress1 =
                                                    "";
                                                valuesCopy.techDegree1 = "";
                                                valuesCopy.techMajor1 = "";
                                                valuesCopy.techMinor1 = "";
                                                valuesCopy.techStart1 = "";
                                                valuesCopy.techEnd1 = "";
                                                valuesCopy.techCreditHours1 =
                                                    "";

                                                setValues(valuesCopy);
                                            }
                                        }}
                                    >
                                        <FaTrashAlt
                                            className="icon trash-icon"
                                            style={{ fontSize: "20px" }}
                                        />
                                    </Button>
                                </Card.Header>
                                <Row className="d-flex justify-content-center  w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            School Name
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="techSchoolName1"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            School Address
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="2"
                                            name="techSchoolAddress1"
                                            maxLength={200}
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7} className="px-0 mx-0">
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Degree
                                        </label>
                                        <Field name="techDegree1" >
                                            {({ field, meta }) => {


                                                let validationCheck;

                                                if (meta.touched && meta.error) {
                                                    validationCheck = "is-invalid";
                                                } else if (
                                                    meta.touched &&
                                                    !meta.error
                                                ) {
                                                    validationCheck = "is-valid";
                                                }
                                                const handleChange = (evt) => {
                                                    field.onChange(evt);

                                                    if (evt.currentTarget.value !== "Some College But No Degree") {
                                                        setFieldValue("techCreditHours1", "0");
                                                    }
                                                    else setFieldValue("techCreditHours1", "");
                                                };
                                                return (
                                                    <>
                                                        <select className={
                                                            "form-control " +
                                                            validationCheck
                                                        }        {...field} onChange={handleChange}>
                                                            <option value="">Select One</option>
                                                            {degrees.map((item) => {
                                                                return (
                                                                    <option
                                                                        key={item}
                                                                        value={item}
                                                                    >
                                                                        {item}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                        {!meta.touched &&
                                                            meta.error ? (
                                                            <p className="text-danger py-0 my-0 ">
                                                                {meta.error}
                                                            </p>
                                                        ) : null}
                                                        {meta.touched &&
                                                            meta.error ? (
                                                            <p className="text-danger py-0 my-0">
                                                                {meta.error}
                                                            </p>
                                                        ) : null}
                                                    </>
                                                );
                                            }}
                                        </Field>

                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Major
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="techMajor1"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            Minor
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            component="textarea"
                                            rows="1"
                                            name="techMinor1"
                                            placeholder="Optional"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            From
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            type="date"
                                            name="techStart1"
                                            value={formatDateToInputFormat(
                                                values.techStart1,
                                            )}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Col>
                                </Row>
                                <Row className="d-flex justify-content-center w-100 mx-auto mt-4">
                                    <Col xs={10} lg={7}>
                                        <label
                                            className="info-label text-center pt-1 "
                                            style={{
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            To
                                        </label>
                                        <GeneralTextAreaField
                                            className="form-control"
                                            type="date"
                                            name="techEnd1"
                                            value={formatDateToInputFormat(
                                                values.techEnd1,
                                            )}
                                            placeholder="MM/DD/YYYY"
                                        />
                                    </Col>
                                </Row>
                                {values.techDegree1 === "Some College But No Degree" ? (<>
                                    <Row className="d-flex justify-content-center mb-4 w-100 mx-auto mt-4 mb-5">
                                        <Col xs={10} sm={7}>
                                            <label
                                                className="info-label mr-1 pt-1 "
                                                style={{
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Credit Hours
                                            </label>
                                            <GeneralTextAreaField
                                                className="form-control"
                                                component="input"
                                                type="text"
                                                name="techCreditHours1"
                                            />
                                        </Col>
                                    </Row></>) : <><div className="mb-5" /></>}

                            </>
                        )}

                    {/* ====================== HS UPLOAD START ====================== */}
                    {values.attendedTechSchool === "Yes" && (
                        <Card>
                            <Card.Header
                                className="header-card"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <span>
                                    {" "}
                                    Additional Information:&nbsp;Upload
                                    Tech/Vocational/Business
                                    Diploma/Certificate/License:
                                </span>
                            </Card.Header>
                            {profile.Schools_FormIn === "Yes" && (
                                <Card.Body className="pb-0">
                                    <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                        <Col className="py-3">
                                            <Row>
                                                <Col className="text-center">
                                                    <h5 className="border-bottom border-warning border-5">
                                                    Tech/Vocational/Business Degree/Certificate On
                                                        File:
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>File Name:</b>{" "}
                                                    {
                                                        profile.Schools_Form_OriginalName
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Upload Date:</b>{" "}
                                                    {formateUploadDate(
                                                        profile.Schools_Form_UploadDate,
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <b>Size:</b>{" "}
                                                    {profile.Schools_Form_FileSize
                                                        ? prettyBytes(
                                                            parseInt(
                                                                profile.Schools_Form_FileSize,
                                                            ),
                                                        )
                                                        : ""}
                                                </Col>
                                            </Row>

                                            <Row>
                                                <FileUploadDelete
                                                    containerName={
                                                        "Schools_Form"
                                                    }
                                                    fileName={
                                                        profile.Schools_Form_OriginalName
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            )}

                            {uploadSchools && (
                                <FileUpload containerName={"Schools_Form"} />
                            )}

                            {profile.Schools_FormIn === "No" && 
                                !uploadSchools && (
                                <Col className="d-flex justify-content-center py-3">
                                    <Button
                                        variant="primary"
                                        className={
                                            uploadSchools ? "btn-danger" : ""
                                        }
                                        onClick={() =>
                                            setUploadSchools(!uploadSchools)
                                        }
                                    >
                                        {uploadSchools
                                            ? "Cancel"
                                            : "Upload New Diploma/Certificate/License"}
                                    </Button>
                                </Col>
                            )}
                                <Card.Header
                                        className="header-card"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "10px",
                                    }}
                                >
                                    <span>
                                        Upload Technical/Vocational/Business Education Transcripts:
                                    </span>
                                </Card.Header>
                                <Card.Body>
                                    {profile.Additional_Info_Field_6In === "Yes" && (
                                        <Row className="bg-white rounded-3 mx-auto shadow-lg border-opacity-10 mt-2 mb-3 border border-5">
                                            <Col className="py-3">
                                                <Row>
                                                    <Col className="text-center">
                                                        <h5 className="border-bottom border-warning border-5">
                                                            {" "}
                                                            Current Technical/Vocational/Business Education Transcripts on File:
                                                        </h5>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>File Name:</b>{" "}
                                                        {
                                                            profile.Additional_Info_Field_6_OriginalName
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>Upload Date:</b>{" "}
                                                        {formateUploadDate(
                                                            profile.Additional_Info_Field_6_UploadDate,
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <b>Size:</b>{" "}
                                                        {profile.Additional_Info_Field_6_FileSize
                                                            ? prettyBytes(
                                                                parseInt(
                                                                    profile.Additional_Info_Field_6_FileSize,
                                                                ),
                                                            )
                                                            : ""}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <FileUploadDelete
                                                        containerName={
                                                            "Additional_Info_Field_6"
                                                        }
                                                        fileName={
                                                            profile.Additional_Info_Field_6_UploadDate
                                                        }
                                                    />
                                                </Row>
                                            </Col>
                                        </Row>
                                    )}
                                </Card.Body>
                                {uploadAddInfo6 && (
                                    <FileUpload
                                        containerName={"Additional_Info_Field_6"}
                                    />
                                )}

                                {profile.Additional_Info_Field_6In === "No" &&
                                    !uploadAddInfo6 && (
                                        <Col className="d-flex justify-content-center mb-4">
                                            <Button
                                                variant="primary"
                                                className={
                                                    uploadAddInfo6 ? "btn-danger" : ""
                                                }
                                                onClick={() =>
                                                    setUploadAddInfo6(!uploadAddInfo6)
                                                }
                                            >
                                                {uploadAddInfo6
                                                    ? "Cancel"
                                                    : "Upload New Technical/Vocational/Business Education Transcripts"}
                                            </Button>
                                        </Col>
                                    )}
                        </Card>
                    )}
                    {/* ====================== HS UPLOAD END ====================== */}
                </Card>

                {checkEducation === false && (
                    <>
                        <Row className="d-flex justify-content-center ">
                            <p className="text-danger w-auto fst-italic fw-bold text-center success-msg">
                                * Some positions within the Navajo Nation might
                                necessitate work education to qualify for these positions.
                                <br /> Please carefully read the job description
                                for the role you&apos;re interested in and enter your education history to qualify.
                            </p>
                        </Row>
                    </>
                )}
                <h5 className="text-center text-danger fst-italic">
                                If you do not submit the appropriate supporting documents, credit may not be awarded.
                    </h5>
            </Container>
        </>
    );
};
